import { TableUI } from "components/design/TableUI";
import React from "react";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { Badge, TaskType } from "components/Task/Badge";
import { FinancialView } from "./FinancialView";
import { FileObject } from "types/Models/fileObject";
import { ConditionalLink } from "components/conditionalLink";

type BusinessFinancialRowType = {
  income_statement: {
    income_statement: FileObject | null;
    income_statement_document_type: string;
    income_statement_generate_link: string;
    income_statement_url: string | null;
  } | null;
  balance_sheet: {
    balance_sheet: FileObject | null;
    balance_sheet_document_type: string;
    balance_sheet_generate_link: string;
    balance_sheet_url: string | null;
  } | null;
  reporting_period: "Mar 2024 - Mar 2024";
  status: TaskType;
};

export const BusinessFinancialTable = ({
  headers,
  data,
  entityName,
  entityId,
}: {
  headers: {}[];
  data: BusinessFinancialRowType[];
  entityName: string;
  entityId: string;
}) => {
  const createColumn = createColumnHelper<BusinessFinancialRowType>();

  const columns = [
    createColumn.accessor("reporting_period", {
      header: "REPORTING PERIOD",
      size: 25,
      cell: (info) => (
        <ConditionalLink
          to={`/admin/bookkeeping-tracker?page=1&service_task_filter=MONTHLY_BOOKKEEPING&default_open_row=${entityId}&search_term=${entityName}`}
          target="_blank"
        >
          <span className="t-text-purple-70 t-text-body-sm t-font-medium t-no-underline hover:t-underline">
            {info.getValue()}
          </span>
        </ConditionalLink>
      ),
    }),
    createColumn.accessor("status", {
      header: "Status",
      size: 20,
      cell: (info) => <Badge type={info.getValue()}>{info.getValue()}</Badge>,
    }),
    createColumn.accessor("income_statement", {
      header: "income_statement",
      size: 28,
      cell: (info) => {
        if (!info.getValue()) {
          return "-";
        }
        return (
          <FinancialView
            item={{
              file_url: info.getValue()?.income_statement_generate_link,
              file_data: info.getValue()?.income_statement,
            }}
          />
        );
      },
    }),
    createColumn.accessor("balance_sheet", {
      header: "balance_sheet",
      size: 28,
      cell: (info) => {
        if (!info.getValue()) {
          return "-";
        }
        return (
          <FinancialView
            item={{
              file_url: info.getValue()?.balance_sheet_generate_link,
              file_data: info.getValue()?.balance_sheet,
            }}
          />
        );
      },
    }),
  ];

  const table = useReactTable({
    columns,
    getCoreRowModel: getCoreRowModel(),
    data: data || [],
  });

  return <TableUI size="regular" table={table} />;
};
